import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
/*import {
  Container,
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { DirectionsBus } from '@mui/icons-material';
//import { useAuth } from '../../context/AuthContext';
import { useAuth } from '../context/AuthContext';
*/

import {
  Container,
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  InputAdornment,  // ← AGREGAR
  IconButton,      // ← AGREGAR
} from '@mui/material';
import { DirectionsBus, Visibility, VisibilityOff } from '@mui/icons-material'; 
//import { useAuth } from '../../context/AuthContext';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
            <DirectionsBus sx={{ fontSize: 60, color: 'primary.main', mb: 1 }} />
            <Typography component="h1" variant="h5">
              Backoffice Transporte
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Iniciar Sesión
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo Electrónico"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            /> */ }
			<TextField
			  margin="normal"
			  required
			  fullWidth
			  name="password"
			  label="Contraseña"
			  type={showPassword ? 'text' : 'password'}
			  id="password"
			  autoComplete="current-password"
			  value={password}
			  onChange={(e) => setPassword(e.target.value)}
			  InputProps={{
				endAdornment: (
				  <InputAdornment position="end">
					<IconButton
					  aria-label="toggle password visibility"
					  onClick={() => setShowPassword(!showPassword)}
					  edge="end"
					>
					  {showPassword ? <VisibilityOff /> : <Visibility />}
					</IconButton>
				  </InputAdornment>
				),
			  }}
			/>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Ingresar'}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
